export default new class DataValidators {
  validateCPF (strCPF) {
    if (strCPF.length === 14) {
      const unMaskedCPF = this.regexCPF(strCPF)
      let sum = 0
      let mod = 0

      if (unMaskedCPF === '00000000000') return 'CPF inválido'

      for (let i = 1; i <= 9; i++) {
        sum = sum + (parseInt(unMaskedCPF.substring(i - 1, i)) * (11 - i))
      }

      mod = (sum * 10) % 11

      if ((mod === 10) || (mod === 11)) mod = 0
      if (mod !== parseInt(unMaskedCPF.substring(9, 10))) return 'CPF inválido'

      sum = 0
      for (let i = 1; i <= 10; i++) sum = sum + (parseInt(unMaskedCPF.substring(i - 1, i)) * (12 - i))
      mod = (sum * 10) % 11

      if ((mod === 10) || (mod === 11)) mod = 0
      if (mod !== parseInt(unMaskedCPF.substring(10, 11))) return 'CPF inválido'
      return true
    } else {
      return true
    }
  }

  regexCPF (strCPF) {
    return strCPF.replace(/(\.|\/|-)/g, '')
  }
}()
